<template>
  <div class="con-frame">
    <Head :activeIndex="activeindex" :isPhoneSize="minbodywidth" ref="header"/>
    <div class="swiper-container swiper-main home">
        <div class="swiper-wrapper">
            <div class="swiper-slide" :style="{height: fullScreenHeight + 'px'}" style="padding-left: 0; padding-right: 0;padding-top:0;padding-bottom: 0;">
              <div class="section container-one" :class="{active: isshowClass}">
                <div class="bg"></div>
                <div class="home-guide">
                  <div class="banner-font">虫虫拜拜 专业消杀<br>为您的工作环境保驾护航<br>
                    <a id="enterprise_a_getprice_price" href="javascript:;" class="price" @click="getprice">获取报价</a>
                  </div>
                </div>
              </div>
            </div>
            <div class="swiper-slide" :style="{height: fullScreenHeight + 'px'}" style="padding-left: 0; padding-right: 0;padding-top:0;padding-bottom: 0;">
              <div class="swiper-container contenter-two">
                <div class="swiper-wrapper">
                  <div class="swiper-slide">
                    <div class="imgshow bg01">
                      <div class="line-frame l01 animated img-delay04" :class="{'fadeInUp':activeindex==1 && Twoactiveindex == 0 }">
                        <span class="line1"></span>
                        <span class="line2"></span>
                        <span class="text animated img-delay08" :class="{'fadeInUp':activeindex==1 && Twoactiveindex == 0 }">重要文件因虫鼠而破损污染</span>
                      </div>
                      <h1 class="tit-d animated img-delay01" :class="{'fadeInUp':activeindex==1 && Twoactiveindex == 0 }"><span>小问题，大破坏！</span></h1>
                      <span class="con con-h animated img-delay02" :class="{'fadeInUp':activeindex==1 && Twoactiveindex == 0 }"><img src="@/assets/img/resources/icon-f.png" alt=""></span>
                    </div>
                  </div>
                  <div class="swiper-slide">
                    <div class="imgshow bg02">
                      <div class="line-frame l02 animated img-delay06" :class="{'fadeIn':activeindex==1 && Twoactiveindex == 1 }">
                        <span class="line1"></span>
                        <span class="line2"></span>
                        <span class="text animated delay-1s" :class="{'fadeInDown':activeindex==1 && Twoactiveindex == 1 }">喷涌的思路和idea被虫鼠打断</span>
                      </div>

                      <div class="line-frame l03 animated img-delay06" :class="{'fadeIn':activeindex==1 && Twoactiveindex == 1 }">
                        <span class="line1"></span>
                        <span class="line2"></span>
                        <span class="text animated delay-1s" :class="{'fadeInDown':activeindex==1 && Twoactiveindex == 1 }">香妃体质难挨虫子叮咬</span>
                      </div>

                      <h1 class="tit-c animated" :class="{'fadeInLeft':activeindex==1 && Twoactiveindex == 1 }"><span>是否受够了害虫的滋扰？</span></h1>
                      <span class="con con-f animated" :class="{'fadeInRight':activeindex==1 && Twoactiveindex == 1 }"><img src="@/assets/img/resources/icon-e.png" alt=""></span>
                      <span class="con con-g animated" :class="{'fadeInRight':activeindex==1 && Twoactiveindex == 1 }"><img src="@/assets/img/resources/icon-b.png" alt=""></span>
                    </div>
                  </div>
                  <div class="swiper-slide">
                    <div class="imgshow bg03">
                      <div class="line-frame l04 animated img-delay06" :class="{'fadeIn':activeindex==1 && Twoactiveindex == 2 }">
                        <span class="line1"></span>
                        <span class="line2"></span>
                        <span class="text animated delay-1s" :class="{'fadeInLeft':activeindex==1 && Twoactiveindex == 2 }">自己动手、找人来弄</span>
                      </div>

                      <div class="line-frame l05 animated img-delay06" :class="{'fadeIn':activeindex==1 && Twoactiveindex == 2 }">
                        <span class="line1"></span>
                        <span class="line2"></span>
                        <span class="text animated delay-1s" :class="{'fadeInLeft':activeindex==1 && Twoactiveindex == 2 }">药剂不安全</span>
                      </div>

                      <div class="line-frame l06 animated img-delay06" :class="{'fadeIn':activeindex==1 && Twoactiveindex == 2 }">
                        <span class="line1"></span>
                        <span class="line2"></span>
                        <span class="text animated delay-1s" :class="{'fadeInRight':activeindex==1 && Twoactiveindex == 2 }">效果一般般，<br>没保障不放心</span>
                      </div>

                      <h1 class="tit-b animated" :class="{'fadeInUp':activeindex==1 && Twoactiveindex == 2 }"><span>寻寻觅觅，问题仍旧没有改善？</span></h1>
                      <span class="con con-c animated" :class="{'fadeInDown':activeindex==1 && Twoactiveindex == 2 }"><img src="@/assets/img/resources/icon-c.png" alt=""></span>
                      <span class="con con-d animated" :class="{'fadeInUp':activeindex==1 && Twoactiveindex == 2 }"><img src="@/assets/img/resources/icon-d.png" alt=""></span>
                      <span class="con con-e animated" :class="{'fadeInDown':activeindex==1 && Twoactiveindex == 2 }"><img src="@/assets/img/resources/icon-e.png" alt=""></span>
                    </div>
                  </div>
                  <div class="swiper-slide">
                    <div class="imgshow bg04">
                      <div class="line-frame l07 animated img-delay06" :class="{'fadeIn':activeindex==1 && Twoactiveindex == 3 }">
                        <span class="line1"></span>
                        <span class="line2"></span>
                        <span class="text animated delay-1s" :class="{'fadeInLeft':activeindex==1 && Twoactiveindex == 3 }">藏在抽屉里的零食被鼠蚁分享</span>
                      </div>

                      <div class="line-frame l08 animated img-delay06" :class="{'fadeIn':activeindex==1 && Twoactiveindex == 3 }">
                        <span class="line1"></span>
                        <span class="line2"></span>
                        <span class="text animated delay-1s" :class="{'fadeInRight':activeindex==1 && Twoactiveindex == 3 }">茶水间蟑螂从饮水机旁爬过</span>
                      </div>

                      <h1 class="tit-e animated" :class="{'fadeInDown':activeindex==1 && Twoactiveindex == 3 }"><span>工作时还要为健康安全烦恼？</span></h1>
                      <span class="con con-a animated" :class="{'fadeInUp':activeindex==1 && Twoactiveindex == 3 }"><img src="@/assets/img/resources/icon-a.svg" alt=""></span>
                      <span class="con con-b animated" :class="{'fadeInRight':activeindex==1 && Twoactiveindex == 3 }"><img src="@/assets/img/resources/icon-b.png" alt=""></span>
                    </div>
                  </div>
                </div>
                <div class="swiper-button-next"></div>
                <div class="swiper-button-prev"></div>
              </div>
            </div>
            <div class="swiper-slide" :style="{height: fullScreenHeight + 'px'}" style="padding-left: 0; padding-right: 0;padding-top:0;padding-bottom: 0;">
              <div class="section container-three">
                <div class="imgshow">
                  <h1 class="animated" :class="{'fadeInUp':activeindex==2 }">我们帮您解决虫害烦恼！</h1>
                  <div class="img">
                    <img class="animated img-delay01" :class="{'fadeInUp':activeindex==2 }" src="@/assets/img/resources/q-professional.svg" alt="">
                    <img class="animated img-delay02" :class="{'fadeInUp':activeindex==2 }" src="@/assets/img/resources/q-safe.svg" alt="">
                    <img class="animated img-delay03" :class="{'fadeInUp':activeindex==2 }" src="@/assets/img/resources/q-price.svg" alt="">
                    <img class="animated img-delay04" :class="{'fadeInUp':activeindex==2 }" src="@/assets/img/resources/q-quick.svg" alt="">
                  </div>
                </div>
              </div>
            </div>
            <div class="swiper-slide" :style="{height: fullScreenHeight + 'px'}" style="padding-left: 0; padding-right: 0;padding-top:0;padding-bottom: 0;">
              <div class="swiper-container content-comm contenter-four">
                <div class="swiper-wrapper">
                  <div class="swiper-slide" style="padding-left: 0; padding-right: 0;padding-top:0;padding-bottom: 0;">
                    <div class="con-professional bg01 imgbg">
                        <div class="text-show textshow-left">
                          <h5 class="animated img-delay01" :class="{'fadeInUp': activeindex==3 && fouractiveindex==0 }">严选用药，放心可靠</h5>
                          <ul class="strict-list">
                            <li class="animated img-delay02" :class="{'fadeInUp': activeindex==3 && fouractiveindex==0 }"><img src="@/assets/img/resources/strict-a.svg" alt=""><span class="text">90%拜耳自有产品<br>官方供应链保障，正品用药不掺假</span></li>
                            <li class="animated img-delay03" :class="{'fadeInUp': activeindex==3 && fouractiveindex==0 }"><img src="@/assets/img/resources/strict-b.svg" alt=""><span class="text">安全环保：产品登记证/产品标签/<br>材料安全数据单（MSDS）三证齐全</span></li>
                            <li class="animated img-delay04" :class="{'fadeInUp': activeindex==3 && fouractiveindex==0 }"><img src="@/assets/img/resources/strict-c.svg" alt=""><span class="text">HACCP认证、美国EPA登记、<br>WHO推荐产品、ICAMA登记多种认证</span></li>
                          </ul>
                        </div>
                    </div>
                  </div>
                  <div class="swiper-slide" style="padding-left: 0; padding-right: 0;padding-top:0;padding-bottom: 0;">
                    <div class="con-professional bg02 imgbg">
                        <div class="text-show">
                          <h5 class="animated img-delay01" :class="{'fadeInUp': activeindex==3 && fouractiveindex==1 }">专职认证工程师</h5>
                          <ul class="engineer-list">
                            <li class="animated img-delay02" :class="{'fadeInUp': activeindex==3 && fouractiveindex==1 }"><img src="@/assets/img/resources/engineer-a.svg" alt="">专职员工，严格筛选</li>
                            <li class="line-h animated img-delay03" :class="{'fadeInUp': activeindex==3 && fouractiveindex==1 }"><img src="@/assets/img/resources/engineer-b.svg" alt="">3重认证：国家专业资格证、 健康证、工作证</li>
                            <li class="animated img-delay04" :class="{'fadeInUp': activeindex==3 && fouractiveindex==1 }"><img src="@/assets/img/resources/engineer-c.svg" alt="">90课时拜耳标准课程培训</li>
                            <li class="animated img-delay05" :class="{'fadeInUp': activeindex==3 && fouractiveindex==1 }"><img src="@/assets/img/resources/engineer-d.svg" alt="">丰富实战经验</li>
                          </ul>
                        </div>
                    </div>
                  </div>
                  <div class="swiper-slide">
                    <div class="con-professional bg03 first">
                      <h5 class="animated img-delay01" :class="{'fadeInUp': activeindex==3 && fouractiveindex==2 }">专业装备</h5>
                      <ul>
                        <li class="animated img-delay02" :class="{'fadeInUp': activeindex==3 && fouractiveindex==2 }"><img src="@/assets/img/resources/equip-d.svg" alt="">胶饵枪</li>
                        <li class="animated img-delay03" :class="{'fadeInUp': activeindex==3 && fouractiveindex==2 }"><img src="@/assets/img/resources/equip-c.svg" alt="">B&G常量喷雾器</li>
                        <li class="animated img-delay04" :class="{'fadeInUp': activeindex==3 && fouractiveindex==2 }"><img src="@/assets/img/resources/equip-a.svg" alt="">ULV冷烟雾机</li>
                        <li class="animated img-delay05" :class="{'fadeInUp': activeindex==3 && fouractiveindex==2 }"><img src="@/assets/img/resources/equip-e.svg" alt="">内窥镜</li>
                        <li class="animated img-delay06" :class="{'fadeInUp': activeindex==3 && fouractiveindex==2 }"><img src="@/assets/img/resources/equip-b.svg" alt="">测距仪</li>
                        <li class="animated img-delay07" :class="{'fadeInUp': activeindex==3 && fouractiveindex==2 }"><img src="@/assets/img/resources/equip-f.svg" alt="">高倍放大镜</li>
                        <li class="animated img-delay08" :class="{'fadeInUp': activeindex==3 && fouractiveindex==2 }"><img src="@/assets/img/resources/equip-g.svg" alt="">专业封堵材料</li>
                        <li class="animated delay-1s" :class="{'fadeInUp': activeindex==3 && fouractiveindex==2 }"><img src="@/assets/img/resources/equip-h.svg" alt="">强力粘鼠板</li>
                      </ul>
                    </div>
                  </div>
                </div>
                <div class="swiper-button-next"></div>
                <div class="swiper-button-prev"></div>
              </div>
              <div class="title-h1 animated img-delay01" :class="{'fadeIn': activeindex==3 }">够专业<br>有保障</div>
            </div>
            <div class="swiper-slide" :style="{height: fullScreenHeight + 'px'}" style="padding-left: 0; padding-right: 0;padding-top:0;padding-bottom: 0;">
              <div class="swiper-container content-comm content-h contenter-five">
                <div class="swiper-wrapper">
                  <div class="swiper-slide" style="padding-left: 0; padding-right: 0;padding-top:0;padding-bottom: 0;">
                    <div class="con-professional bg04 imgbg">
                        <div class="counselor">
                          <h5 class="animated img-delay01" :class="{'fadeInUp': activeindex==4 && fiveActiveindex==0 }">专属客服顾问</h5>
                          <div class="line-text animated img-delay02" :class="{'fadeInRight': activeindex==4 && fiveActiveindex==0 }">
                            <span class="text"><em>365天无休</em></span>
                            <span class="line"></span>
                          </div>
                          <div class="line-text animated img-delay02" :class="{'fadeInRight': activeindex==4 && fiveActiveindex==0 }">
                            <span class="text"><em>快速响应</em></span>
                            <span class="line"></span>
                          </div>
                          <div class="line-text animated img-delay03" :class="{'fadeInRight': activeindex==4 && fiveActiveindex==0 }">
                            <span class="text"><em>全方位售前售后支持</em></span>
                            <span class="line"></span>
                          </div>
                        </div>
                    </div>
                  </div>
                  <div class="swiper-slide" style="padding-left: 0; padding-right: 0;padding-top:0;padding-bottom: 0;">
                    <div class="con-professional bg05 imgbg">
                        <div class="support">
                          <h5 class="animated img-delay01" :class="{'fadeInUp': activeindex==4 && fiveActiveindex==1 }">灵活系统支持</h5>
                          <img  class="animated img-delay02" :class="{'zoomIn': activeindex==4 && fiveActiveindex==1 }" src="@/assets/img/resources/quick-icon-e.png" alt="">
                          <ul>
                            <li class="animated img-delay03" :class="{'zoomIn': activeindex==4 && fiveActiveindex==1 }"><img src="@/assets/img/resources/quick-icon-f.png" alt="">专属企业账户，<br>完整档案记录</li>
                            <li class="animated img-delay04" :class="{'zoomIn': activeindex==4 && fiveActiveindex==1 }"><img src="@/assets/img/resources/quick-icon-a.png" alt="">微信/支付宝/对公转账<br>多种支付方式</li>
                            <li class="animated img-delay05" :class="{'zoomIn': activeindex==4 && fiveActiveindex==1 }"><img src="@/assets/img/resources/quick-icon-b.png" alt="">方案在线查看，一键导出PDF/纸质方案，灵活索取</li>
                            <li class="animated img-delay06" :class="{'zoomIn': activeindex==4 && fiveActiveindex==1 }"><img src="@/assets/img/resources/quick-icon-c.png" alt="">在线极速开票——<br>免去繁琐财务流程</li>
                            <li class="animated img-delay07" :class="{'zoomIn': activeindex==4 && fiveActiveindex==1 }"><img src="@/assets/img/resources/quick-icon-d.png" alt="">服务报告一键查询，<br>迅速复盘治理情况、<br>用药情况</li>
                          </ul>
                        </div>
                    </div>
                  </div>
                </div>
                <div class="swiper-button-next"></div>
                <div class="swiper-button-prev"></div>
              </div>
              <div class="title-h1 animated img-delay01" :class="{'fadeIn': activeindex==4 }">够贴心<br>更便捷</div>
            </div>
            <div class="swiper-slide" :style="{height: fullScreenHeight + 'px'}" style="padding-left: 0; padding-right: 0;padding-top:0;padding-bottom: 0;">
              <div class="swiper-container contenter-six">
                <div class="swiper-wrapper">
                  <div class="swiper-slide" style="padding-left: 0; padding-right: 0;padding-top:0;padding-bottom: 0;">
                    <div class="service" :style="{height: fullScreenHeight - 250 + 'px'}">
                      <img class="animated img-delay01" :class="{'fadeInUp': activeindex==5 && sixActiveindex==0 }" src="@/assets/img/resources/banner-6-1.jpg" alt="">
                      <div class="service-con animated img-delay03" :class="{'fadeInUp': activeindex==5 && sixActiveindex==0 }">
                        <h5>定向灭治</h5>
                        <p>蟑螂、老鼠、跳蚤、白蚁、蚊蝇等各种害虫的专业防治</p>
                        <ul class="worm">
                          <li><img src="@/assets/img/resources/worm-a.svg" alt="">蟑螂</li>
                          <li><img src="@/assets/img/resources/worm-b.svg" alt="">老鼠</li>
                          <li><img src="@/assets/img/resources/worm-c.svg" alt="">跳蚤</li>
                          <li><img src="@/assets/img/resources/worm-d.svg" alt="">飞虫</li>
                          <li><img src="@/assets/img/resources/worm-e.svg" alt="">其他害虫</li>
                          <li><img src="@/assets/img/resources/worm-f.svg" alt="">综合定制</li>
                        </ul>
                      </div>
                    </div>
                  </div>
                  <div class="swiper-slide" style="padding-left: 0; padding-right: 0;padding-top:0;padding-bottom: 0;">
                    <div class="service" :style="{height: fullScreenHeight - 250 + 'px'}">
                      <img class="animated img-delay01" :class="{'fadeInUp': activeindex==5 && sixActiveindex==1 }" src="@/assets/img/resources/banner-6-2.jpg" alt="">
                      <div class="service-con animated img-delay03" :class="{'fadeInUp': activeindex==5 && sixActiveindex==1 }">
                        <h5>多种套餐</h5>
                        <p>多种套餐组合任你挑选</p>
                        <ul class="combo">
                          <li>月度套餐<span>1个月</span></li>
                          <li>季度套餐<span>3个月</span></li>
                          <li>半年套餐<span>6个月</span></li>
                          <li>全年套餐<span>12个月</span></li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="swiper-button-next"></div>
                <div class="swiper-button-prev"></div>
              </div>
              <div class="title-h1 rt animated img-delay01" :class="{'fadeIn': activeindex==5 }">服务内容</div>
            </div>
            <div class="swiper-slide" :style="{height: fullScreenHeight + 'px'}" style="padding-left: 0; padding-right: 0;padding-top:0;padding-bottom: 0;">
              <div class="swiper-container contenter-seven">
                <div class="swiper-wrapper">
                  <div class="swiper-slide" style="padding-left: 0; padding-right: 0;padding-top:0;padding-bottom: 0;">
                    <div class="flow animated img-delay01" :class="{'fadeInUp': activeindex==6 && sevenActiveindex==0 }" :style="{height: fullScreenHeight - 460 + 'px'}">
                      <img src="@/assets/img/resources/flow-a.jpg" alt="">
                      <div class="textshow">
                        <h1>01</h1>
                        <div class="tit">
                          <h3>环境分析</h3>
                          <p>了解害虫主要由什么原因导致</p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="swiper-slide" style="padding-left: 0; padding-right: 0;padding-top:0;padding-bottom: 0;">
                    <div class="flow animated img-delay01" :class="{'fadeInUp': activeindex==6 && sevenActiveindex==1 }" :style="{height: fullScreenHeight - 460 + 'px'}">
                      <img src="@/assets/img/resources/flow-b.jpg" alt="">
                      <div class="textshow">
                        <h1>02</h1>
                        <div class="tit">
                          <h3>全面勘查</h3>
                          <p>锁定害虫的感染密度和滋生地分布</p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="swiper-slide" style="padding-left: 0; padding-right: 0;padding-top:0;padding-bottom: 0;">
                    <div class="flow animated img-delay01" :class="{'fadeInUp': activeindex==6 && sevenActiveindex==2 }" :style="{height: fullScreenHeight - 460 + 'px'}">
                      <img src="@/assets/img/resources/flow-c.jpg" alt="">
                      <div class="textshow">
                        <h1>03</h1>
                        <div class="tit">
                          <h3>治防并重</h3>
                          <p>对于易感染区域同样做好防护</p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="swiper-slide" style="padding-left: 0; padding-right: 0;padding-top:0;padding-bottom: 0;">
                    <div class="flow animated img-delay01" :class="{'fadeInUp': activeindex==6 && sevenActiveindex==3 }" :style="{height: fullScreenHeight - 460 + 'px'}">
                      <img src="@/assets/img/resources/flow-d.jpg" alt="">
                      <div class="textshow">
                        <h1>04</h1>
                        <div class="tit">
                          <h3>持续监测</h3>
                          <p>服务期内紧密关注现场动态，快速响应</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="swiper-button-next"></div>
                <div class="swiper-button-prev"></div>
              </div>
              <div class="title-h1 dafter animated img-delay01" :class="{'fadeIn': activeindex==6 }">专业系统流程<span><em>严谨治虫</em></span><b class="bot-tip">每一环节都不疏漏</b></div>
              <div class="rt-title animated img-delay01" :class="{'fadeIn': activeindex==6 }">IPM 综合虫害管理<span>每一环节都不疏漏</span></div>
            </div>
            <div class="swiper-slide" :style="{height: fullScreenHeight + 'px'}" style="padding-left: 0; padding-right: 0;padding-top:0;padding-bottom: 0;">
              <div class="section container-eight">
                <div class="evaluate">
                  <h1 class="animated img-delay01" :class="{'fadeIn': activeindex==7 }">客户评价</h1>
                  <div class="swiper-container container-eight-swiper">
                    <div class="swiper-wrapper">
                      <div class="swiper-slide" v-for="(list,ii) in evaluateList" :key="ii">
                        <div class="evaluate-show animated img-delay02" :class="{'fadeInUp': activeindex==7 && eightActiveindex==0 }">
                          <div class="message">{{list.text}}</div>
                          <div class="specialty"><span v-for="(object,aa) in list.key.split('、')" :key="aa+'1'">{{object}}</span></div>
                          <el-rate
                            v-model="list.star"
                            disabled
                            :colors="['#FAE1A5', '#FAE1A5', '#FAE1A5']"
                            text-color="#ff9900">
                          </el-rate>
                          <span class="name"><i class="iconfont" :class="list.product_icon"></i></span>
                        </div>
                      </div>
                    </div>
                    <div class="swiper-button-next"></div>
                    <div class="swiper-button-prev"></div>
                  </div>
                </div>
              </div>
            </div>
            <div class="swiper-slide scroll-wrap" :style="{height: fullScreenHeight + 'px'}" style="padding-left: 0; padding-right: 0;padding-top:0;padding-bottom: 0;">
              <div class="swiper-container contenter-nine">
                <div class="swiper-wrapper">
                  <div class="swiper-slide" style="height:auto; display: block;">
                    <div class="section container-foot" :style="{height: fullScreenHeight - 80 + 'px'}">
                        <div class="banner-font">虫虫拜拜 专业消杀<br>为您的工作环境保驾护航<br>
                        <a id="enterprise_a_getprice_0" href="javascript:;" class="price" @click="getprice">获取报价</a>
                        </div>
                    </div>
                  </div>
                  <div class="swiper-slide" style="height:auto; display: block;">
                    <div class="foot-text">
                      <div class="text-show">
                        <h6>预定须知</h6>
                        <dl>
                          <dt>1.</dt>
                          <dd>目前{{availableCityTips}}已开通服务（其中上海崇明等部分区域仍在筹备，详情请咨询客服），其他城市地区陆续开放中。</dd>
                          <dt>2.</dt>
                          <dd>办公室服务套餐中包含多次上门的（如老鼠、跳蚤），若客户中止，放弃后续上门，则虫虫拜拜相应的服务保障亦无法保证；套餐中包含周期性上门的（如季度套餐、半年套餐、全年套餐），双方可以协商常规服务的具体上门时间，提前或者延后，但总服务周期跨度（季度、半年或一年）不随该变动发生改变。</dd>
                          <dt>3.</dt>
                          <dd>如您选择的服务需上门勘查后才能给出具体方案报价，您需先支付此次上门勘察的费用；该费用可在后续服务费用中减免。</dd>
                          <dt>4.</dt>
                          <dd>餐厅、酒吧、酒店、食品工厂、仓库、大型写字楼、工厂、小区物业、各类经营性场所等暂未包含在办公室服务范围内，如有需求请咨询我们的客服热线：4001888282。</dd>
                        </dl>
                      </div>
                    </div>
                    <Footer :isPhoneSize="minbodywidth"></Footer>
                  </div>
                </div>
                <!-- <div class="swiper-scrollbar"></div> -->
              </div>
            </div>
        </div>
    </div>

    <i id="enterprise_i_swiperClick_bottom" class="el-icon-arrow-down icondown-bottom" :class="{'icondown2': activeindex == 0 || activeindex == 2 || activeindex == 7}" @click="swiperClick" v-show="activeindex < 8"></i>
    <a id="enterprise_a_getprice_btn" href="javascript:;" class="price-btn" :class="{'show':activeindex && activeindex < 8,'white':activeindex == 2 || activeindex == 7}" @click="getprice"><img src="@/assets/img/resources/price-white.svg" alt="" v-if="activeindex == 2 || activeindex == 7"><img v-else src="@/assets/img/resources/price.svg" alt="">获取报价</a>
  </div>
</template>

<script>
import Swiper from 'swiper'
import Bus from '@/controller/bus';
import '@/assets/css/swiper.min.css';
import evaluateData from '@/controller/data'
import Head from '@/components/Head'
import Footer from '@/components/Footer'
import meta from '@/controller/metaInfo'

export default {
  name: 'Enterprise',
  components: {
    Head,
    Footer
  },
  data(){
    return {
      fullScreenHeight: 1000,
      isshowClass: false,
      activeindex: 0,
      Twoactiveindex: 0,
      fouractiveindex: 0,
      fiveActiveindex: 0,
      sixActiveindex: 0,
      sevenActiveindex: 0,
      eightActiveindex: 0,
      swiper: '',
      swiper2: '',
      swiper3: '',
      swiper4: '',
      swiper5: '',
      swiper6: '',
      swiper7: '',
      swiper8: '',
      evaluateList: evaluateData.customer_evaluate,
      minbodywidth: false,
      availableCityTips: ''
    }
  },
  metaInfo() {
    return meta.metaSet(this.$route)
  },
  mounted:function(){
    let self = this
    self.changeScreenHeight()
    self.$nextTick(function(){
      self.availableCityTips = window.localStorage.getItem("availableCityName")
      self.swiper = new Swiper('.swiper-main', {
          speed: 800,
          direction: 'vertical',
          slidesPerView: 'auto',
          autoHeight: true,
          simulateTouch: false,
          mousewheel: true,
          nested: true,
          observer:true,
          observeParents:true,
          preventInteractionOnTransition : true,
          // noSwipingClass : 'scroll-wrap',
          on: {
            init: function(){
              self.isshowClass =  true
              self.activeindex = this.activeIndex
              this.emit('transitionEnd');
            },
            slideChangeTransitionStart: function () {
              self.activeindex = this.activeIndex
            },
            slideChangeTransitionEnd: function () {
              if(this.activeIndex == 8){
                self.swiper.mousewheel.disable();
                // self.swiper8.init();//现在才初始化
                self.swiper8.slideTo(0, 0, false)
                // self.swiper8.update();
              }
            }
          }
      });

      self.swiper2 = new Swiper('.contenter-two', {
        slidesPerView: 1,
        spaceBetween: 30,
        loop: true,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
        on: {
            slideChangeTransitionStart: function () {
              self.Twoactiveindex = this.realIndex
            }
        }
      });

      self.swiper3 = new Swiper('.contenter-four', {
        slidesPerView: 'auto',
        centeredSlides: true,
        spaceBetween: 10,
        paginationClickable:true,
        loop: true,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
        on: {
            slideChangeTransitionStart: function () {
              self.fouractiveindex = this.realIndex
            }
        }
      });

      self.swiper4 = new Swiper('.contenter-five', {
        slidesPerView: 'auto',
        centeredSlides: true,
        spaceBetween: 10,
        paginationClickable:true,
        loop: true,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
        on: {
            slideChangeTransitionStart: function () {
              self.fiveActiveindex = this.realIndex
            }
        }
      });

      self.swiper5 = new Swiper('.contenter-six', {
        slidesPerView: 1,
        spaceBetween: 10,
        loop: true,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
        on: {
            slideChangeTransitionStart: function () {
              self.sixActiveindex = this.realIndex
            }
        }
      });

      self.swiper6 = new Swiper('.contenter-seven', {
        slidesPerView: 1,
        spaceBetween: 30,
        loop: true,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
        on: {
            slideChangeTransitionStart: function () {
              self.sevenActiveindex = this.realIndex
            }
        }
      });

      self.swiper7 = new Swiper('.container-eight-swiper', {
        slidesPerView: 1,
        spaceBetween: 30,
        loop: true,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
        on: {
            slideChangeTransitionStart: function () {
              self.eightActiveindex = this.realIndex
            }
        }
      });

      self.swiper8 = new Swiper('.contenter-nine', {
        // init: false,
        direction: 'vertical',
        slidesPerView: 'auto',
        freeMode: true,
        mousewheel: true,
        observer:true,
        observeParents:true,
        watchSlidesProgress : true,
        nested: true,
        on:{
          init: function(){
           console.log('8初始化')
          },
          progress: function(progress){
            if(self.swiper.activeIndex == 8){
              console.log('ccc')
              console.log(progress)
              if(parseFloat(progress) < 0 || progress == '-0'){
                self.swiper.mousewheel.enable()
                self.swiper.allowTouchMove= true;
              }else {
                self.swiper.mousewheel.disable()
                self.swiper.allowTouchMove= false;
              }
            }
          }
        }
      });

    });

    window.onresize = () => {
      this.changeScreenHeight()
    }

    Bus.$on('enterpriseTop',(res)=>{
      if(res){
        self.topNavClick()
      }
    });
  },
  beforeDestroy(){
    this.$ga.removeScroll()
  },
  destroyed(){
    Bus.$off('enterpriseTop')
  },
  methods: {
    topNavClick(){
      this.swiper.slideTo(0, 2000, false);
    },
    changeScreenHeight(){
        this.fullScreenHeight = document.documentElement.clientHeight
        this.minbodywidth = document.documentElement.clientWidth > 768 ? false : true
        console.log(this.minbodywidth)
    },
    swiperClick(){
      let self = this
      self.swiper.slideNext();
    },
    getprice(){
      this.$refs.header.$emit('sylogin','')
      // this.$router.push({name: 'Price'})
    }
  },
  destroyed(){
    this.swiper.destroy(false);
    this.swiper2.destroy(false);
    this.swiper3.destroy(false);
    this.swiper4.destroy(false);
    this.swiper5.destroy(false);
    this.swiper6.destroy(false);
    this.swiper7.destroy(false);
    this.swiper8.destroy(false);

    window.onresize = null;
  }
}
</script>

 <style scoped>
    .swiper-container {
        width: 100%;
        height: 100%;
        margin-left: auto;
        margin-right: auto;
    }

    .swiper-main {
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
      height: 100%;
    }
    .swiper-slide {
        text-align: center;
        font-size: 18px;
        background: #fff;
    }

    .contenter-two .swiper-slide,.contenter-four .swiper-slide,.contenter-five .swiper-slide,.contenter-six .swiper-slide,.contenter-seven .swiper-slide,.contenter-eight .swiper-slide {
      height: 100%;
      display: flex !important;
      -webkit-box-pack: center;
      -ms-flex-pack: center;
      -webkit-justify-content: center;
      justify-content: center;
      -webkit-box-align: center;
      -ms-flex-align: center;
      -webkit-align-items: center;
      align-items: center;
    }

    .section.container-eight {
      display: flex !important;
      -webkit-box-pack: center;
      -ms-flex-pack: center;
      -webkit-justify-content: center;
      justify-content: center;
      -webkit-box-align: center;
      -ms-flex-align: center;
      -webkit-align-items: center;
      align-items: center;
    }
</style>


// WEBPACK FOOTER //
// src/views/enterprise/Enterprise.vue